export default __webpack_public_path__ + "static/media/bookmark.ae4182af.svg";